import $ from 'jquery'
import Overlay from 'ol/Overlay'
import ImageViewer from './ImageViewer'
import { newLineToBr, encodeHtmlTags } from '../utils/html'

import Feature from 'ol/Feature'
/**
 * @param {Object} config
 * @constructor
 */
export default function Popup(config) {
  $.extend(this, config || {})

  this.defaultElement = document.getElementById('identify-properties')
  this.customElementContainer = document.createElement('div')
  this.placement =
    this.options && this.options.placement ? this.options.placement : 'top'
  this.popup = new Overlay({
    element: this.defaultElement,
    positioning: 'bottom-center'
  })

  this.action = $('<a>', {
    class: 'action',
    style: 'display:none;'
  })
  $(this.defaultElement)
    .find('a')
    .after(this.action)

  this.actionIcon = $('<i>', {
    class: 'fa icon-only'
  })
  this.actionIcon.appendTo(this.action)
  this.imageViewer = new ImageViewer()
}

/**
 * Set features to be presented
 * @param {Array.<Feature>} features
 */
Popup.prototype.setFeatures = function(features) {
  features.forEach(this.generateMenuItem.bind(this))
}

/**
 * Remove popup overlay from map
 */
Popup.prototype.destroy = function() {
  $('.popover-footer .pagination-right').off('click')
  $('.popover-footer .pagination-left').off('click')
  $('.popover-footer .pagination-page a').off('click')
  $('#identify-properties .popover-close').off('click')
  $('.popover-title').off('mousedown touchstart mouseup mouseleave touchend')
  $('#identify-properties').off('touchstart touchmove touchend')
  $('#identify-properties')
    .find('img')
    .off('click')
  this.map.removeOverlay(this.popup)
}

/**
 * @param {Object} index
 * @param {Object} features
 */
Popup.prototype.toggleStates = function(index, features) {
  if (features.length < 2) {
    $('.popover-footer .pagination-left').addClass('disabled')
    $('.popover-footer .pagination-right').addClass('disabled')
  } else if (index === 0) {
    $('.popover-footer .pagination-left').addClass('disabled')
    $('.popover-footer .pagination-right').removeClass('disabled')
  } else if (index === features.length - 1) {
    $('.popover-footer .pagination-left').removeClass('disabled')
    $('.popover-footer .pagination-right').addClass('disabled')
  } else {
    $('.popover-footer .pagination-right').removeClass('disabled')
    $('.popover-footer .pagination-left').removeClass('disabled')
  }
  $('.popover-footer .pagination-page').each(function(i, e) {
    var ci = parseInt(
      $(e)
        .find('a')
        .first()
        .text(),
      10
    )
    if (index === ci) {
      $(e).addClass('active')
    } else {
      $(e).removeClass('active')
    }
  })
}

/**
 * @param {Object} features
 * @return {String}
 */
Popup.prototype.generatePagination = function(features) {
  var str = ''
  str += '<ul class="pagination pagination-sm">'
  str +=
    '<li class="pagination-left"><a ><i class="fa fa-chevron-left"></i></a></li>'
  str += features
    .map(function(feature, index) {
      return '<li class="pagination-page"><a >' + index + '</a></li>'
    })
    .join('')
  str +=
    '<li class="pagination-right"><a "><i class="fa fa-chevron-right"></i></a></li>'
  return str
}

/**
 * @param {Object} feature
 * @return {String}
 */
Popup.prototype.generateTable = function(feature) {
  var properties = $.extend({}, feature.getProperties())
  delete properties.geometry
  delete properties.olga_

  var metadata =
    feature.get('olga_') && feature.get('olga_').metadata
      ? feature.get('olga_').metadata
      : {}

  var calculateProperty = (result, key) => {
    result[key] = this.parsePropertyValue(properties, feature, key)
    return result
  }

  var existsInFieldAliases = function(prop) {
    return (
      metadata.fieldAliases &&
      Object.keys(metadata.fieldAliases).indexOf(prop) > -1
    )
  }
  var sortedProperties = Object.keys(metadata.fieldAliases || {}).reduce(
    (result, key) => {
      result[key] = null
      return result
    },
    {}
  )

  var calculatedProperties = Object.keys(properties).reduce(
    calculateProperty,
    sortedProperties
  )

  if (metadata.fieldAliases) {
    calculatedProperties = Object.keys(metadata.fieldAliases).reduce(
      calculateProperty,
      calculatedProperties
    )
  }

  var propertiesWithImages = Object.keys(calculatedProperties).reduce(
    (result, key) => {
      if (this.isImage(metadata.imageFields, key)) {
        result[key] = this.getImage(
          metadata.imageFields,
          key,
          calculatedProperties
        )
      }
      return result
    },
    calculatedProperties
  )

  var str = ''
  str += '<table>'
  str += '<tbody>'

  var generateRow = function(key) {
    str += '<tr>'
    str += '<th>' + this.parsePropertyKey(feature, key) + '</th>'
    str += '<td>' + this.parsePropertyValue(properties, feature, key) + '</td>'

    str += '</tr>'
  }

  Object.keys(propertiesWithImages)
    .filter(key => !this.isImageThumbnail(metadata.imageFields, key))
    .filter(
      key =>
        metadata.hideFields === undefined ||
        metadata.hideFields === false ||
        existsInFieldAliases(key)
    )
    .forEach(key => {
      str += '<tr>'
      str += '<th>' + this.parsePropertyKey(feature, key) + '</th>'
      str += '<td>' + propertiesWithImages[key] + '</td>'

      str += '</tr>'
    })

  str += '</tbody>'
  str += '</table>'

  return str
}

/**
 * @param {Object} feature
 * @param {Object} identify
 */
Popup.prototype.showFeature = function(feature) {
  const config = feature.get('olga_')
  const metadata = config ? config.metadata : {}
  let title = config ? config.name : ''
  $('#identify-properties .popover-content').html(this.generateTable(feature))
  title =
    config && config.metadata && config.metadata.displayField
      ? feature.get(config.metadata.displayField)
      : title
  $('#identify-properties .popover-title').html(title)

  let top = 0
  let left = 0

  let popupHeight = $('#identify-properties').height()
  let popupWidth = $('#identify-properties').width()
  let arrow = $('#identify-properties').children('.arrow')
  let arrowHeight = arrow.outerHeight()
  let css = {}
  switch (this.placement) {
    case 'left':
      top = (arrowHeight - popupHeight) / 2
      left = -(popupWidth + arrowHeight)
      css = {
        transform: 'rotate(-90deg)',
        left: '100%',
        'margin-left': '10px',
        top: '50%'
      }
      break
    case 'right':
      top = -(popupHeight - arrowHeight) / 2
      left = arrowHeight
      css = {
        transform: 'rotate(90deg)',
        left: '0%',
        'margin-left': '-30px',
        top: '50%'
      }
      break
    case 'bottom':
      top = arrowHeight * 2
      left = -(popupWidth / 2)
      css = { transform: 'rotate(180deg)', top: -arrowHeight }
      break
    case 'top':
      top = -popupHeight
      left = -(popupWidth / 2)
      break
    default:
      //Top or unset
      break
  }
  arrow.css(css)

  $('#identify-properties').css({
    top: top,
    left: left
  })
  this.autoSelection.featureSelection.clearFeatures()
  this.autoSelection.featureSelection.addFeature(feature)

  this.deactivateAction()

  const popupAction = metadata.popupAction

  if (popupAction) {
    this.activateAction(popupAction, feature)
  }
}

/**
 * Show action icon and add click event binding
 * @param {Object} popupAction
 * @param {Object} feature
 */
Popup.prototype.activateAction = function(popupAction, feature) {
  var label = popupAction.label
  var icon = popupAction.icon || 'fa-check-circle'

  this.action.attr('title', label)
  this.actionIcon.addClass(icon)

  this.action.show()
  this.action.on('click', () => this.actionCallback(feature))
}

/**
 * Hide action icon and remove click event binding
 */
Popup.prototype.deactivateAction = function() {
  this.action.off('click')
  this.action.hide()
}

/**
 * Check if property is an object with label and value set
 * @param {Object} prop
 * @return {Bool}
 */
Popup.prototype.isPropertyLabelValueObject = function(prop) {
  return prop && prop.label && prop.value
}

/**
 * Check if property is an image field
 * @param {Object} prop
 * @return {Bool}
 */
Popup.prototype.isImage = function(imageFields, key) {
  if (!imageFields) {
    return false
  }

  return imageFields[key]
}

/**
 * Check if property is an image field
 * @param {Object} prop
 * @return {Bool}
 */
Popup.prototype.isImageThumbnail = function(imageFields, key) {
  if (!imageFields) {
    return false
  }

  return (
    Object.keys(imageFields).filter(k => imageFields[k].thumbnailField === key)
      .length > 0
  )
}

/**
 * Preload image
 * @param {String} imageUrl
 */
Popup.prototype.preloadImage = function(imageUrl) {
  $('<img />').attr('src', imageUrl)
}

/**
 * Get image from field
 * @param {Object} prop
 * @return {String}
 */
Popup.prototype.getImage = function(imageFields, key, props) {
  const imageFieldMetadata = imageFields[key]
  const thumbnailField = imageFieldMetadata.thumbnailField
  const imageUrl = props[key]
  const thumbUrl = props[thumbnailField]

  if (thumbUrl) {
    this.preloadImage(imageUrl)
    return `<img src="${thumbUrl ||
      imageUrl}" data-original-url="${imageUrl}" />`
  }

  return `<i>Bild saknas</i>`
}

/**
 * @param {Object} feature
 * @param {String} key
 * @return {String}
 */
Popup.prototype.parsePropertyKey = function(feature, key) {
  var parsedKey = key

  var metadata = this.getFeatureMetadata(feature)

  // Check for computed fields
  if (
    metadata &&
    metadata.fieldAliases &&
    this.isPropertyLabelValueObject(metadata.fieldAliases[key])
  ) {
    parsedKey = metadata.fieldAliases[key].label
  } else if (metadata && metadata.fieldAliases && metadata.fieldAliases[key]) {
    parsedKey = metadata.fieldAliases[key]
  }

  return parsedKey
}

/**
 * @param {Array} properties
 * @param {Object} feature
 * @param {String} key
 * @return {String}
 */
Popup.prototype.parsePropertyValue = function(properties, feature, key) {
  var value = ''

  var metadata = this.getFeatureMetadata(feature)
  var fields = metadata.fieldAliases
  var property

  if (fields && fields[key]) {
    property = fields[key]
  }

  if (property && this.isPropertyLabelValueObject(property)) {
    value = this.getCalculatedValues(properties, property, metadata)
  } else {
    value = properties[key]
  }

  if (typeof value === 'number') value = Math.round(value * 100) / 100

  let tryJSON
  try {
    tryJSON = JSON.parse(value)
  } catch (e) {}

  if (tryJSON instanceof Object) {
    const kvs = Object.keys(tryJSON).map(key => `${tryJSON[key]}`)
    value = kvs.map(kv => `${kv}`).join('<br>')
  }

  if (value === null) {
    value = ''
  }

  if (
    metadata.encodeFields &&
    metadata.encodeFields.indexOf(property || key) !== -1
  ) {
    value = newLineToBr(encodeHtmlTags(value))
  }

  return value
}

/**
 * @param {Array} properties
 * @param {Object} property
 * @return {String}
 */
Popup.prototype.getCalculatedValues = function(properties, property, metadata) {
  var parsedValue, valueReferences, valueRefTarget, valueRefTargetValue

  parsedValue = property.value

  var regexpWordsBetweenTwoDollarSigns = /\$\S*\$/g
  var regexpDollarSigns = /\$/g

  valueReferences = property.value.match(regexpWordsBetweenTwoDollarSigns)
  if (valueReferences && valueReferences.length) {
    valueReferences.forEach(function(valueRef) {
      valueRefTarget = valueRef.replace(regexpDollarSigns, '')
      valueRefTargetValue = properties[valueRefTarget]
      if (
        metadata.encodeFields &&
        metadata.encodeFields.indexOf(valueRefTarget) !== -1
      ) {
        valueRefTargetValue = newLineToBr(encodeHtmlTags(valueRefTargetValue))
      }

      parsedValue = parsedValue.replace(valueRef, valueRefTargetValue)
    }, this)
  }

  return parsedValue
}

/**
 * @param {Feature} feature
 * @return {Object}
 */
Popup.prototype.getFeatureMetadata = function(feature) {
  var metadata =
    feature.get('olga_') && feature.get('olga_').metadata
      ? feature.get('olga_').metadata
      : {}

  return metadata
}

/**
 * @param {Object} features
 * @param {Object} identify
 * @param {Object} coordinate
 */
Popup.prototype.show = function(features, coordinate) {
  if (features.length === 0) {
    return
  }
  this.destroy()
  var index = 0

  if (this.autoSelection.api.identify.customPopupHandler) {
    let el = this.autoSelection.api.identify.customPopupHandler(
      features,
      feature => {
        this.autoSelection.featureSelection.clearFeatures()
        this.autoSelection.featureSelection.addFeature(feature)
      }
    )
    if (el === undefined || el === null) {
      $(this.defaultElement).hide()
      this.popup.setElement(this.defaultElement)
    } else {
      this.customElementContainer.innerHTML = ''
      this.customElementContainer.appendChild(el)
      this.popup.setElement(this.customElementContainer)
    }
  } else {
    this.popup.setElement(this.defaultElement)
  }

  var feature = features[0]
  this.map.addOverlay(this.popup)
  this.popup.setPosition(coordinate)

  this.showFeature(feature)

  if (features.length > 1) {
    $('#identify-properties .popover-footer').html(
      this.generatePagination(features)
    )
  } else {
    $('#identify-properties .popover-footer').html('')
  }

  $('.popover-footer .pagination-right').on(
    'click',
    $.proxy(function(e) {
      if ($(e.currentTarget).hasClass('disabled')) {
        return
      }
      var feature = features[++index]
      this.showFeature(feature)
      this.toggleStates(index, features)
    }, this)
  )
  $('.popover-footer .pagination-left').on(
    'click',
    $.proxy(function(e) {
      if ($(e.currentTarget).hasClass('disabled')) {
        return
      }
      var feature = features[--index]
      this.showFeature(feature)
      this.toggleStates(index, features)
    }, this)
  )
  $('.popover-footer .pagination-page a').on(
    'click',
    $.proxy(function(e) {
      index = parseInt($(e.target).text(), 10)
      var feature = features[index]
      this.showFeature(feature)
      this.toggleStates(index, features)
    }, this)
  )

  $('#identify-properties .popover-close').on(
    'click',
    $.proxy(function() {
      this.destroy()
      this.autoSelection.featureSelection.clearFeatures()
    }, this)
  )

  // Without stopping propagation the content in the popup div will not be scrollable on touch enabled devices.
  // OL3 goog.events.getProxy() prevents touch-events in overlays
  $('#identify-properties').on('touchstart touchmove touchend', function(e) {
    e.stopImmediatePropagation()
  })

  const createOpacityHandler = opacity => e => {
    e.preventDefault()
    $('#identify-properties').animate(
      { opacity },
      {
        duration: 100,
        queue: false
      }
    )
  }

  $('.popover-title').on('mousedown touchstart', createOpacityHandler(0.3))
  $('.popover-title').on('mouseup mouseleave touchend', createOpacityHandler(1))
  $('#identify-properties').on('click', e => {
    const $target = $(e.target)
    if ($target.is('img')) {
      this.imageViewer.show($target.attr('data-original-url'))
    }
  })

  this.toggleStates(index, features)
  this.popup.panIntoView({
    margin: 41,
    animation: {
      duration: 500
    }
  })
  //this.panIntoView(coordinate)
}

/**
 * @param {Object} coordinate
 */
Popup.prototype.panIntoView = function(coordinate) {
  var mapSize = this.map.getSize()
  var popupSize = [
    this.popup.getElement().offsetWidth,
    this.popup.getElement().offsetHeight + 40
  ]

  var popupPosition = this.map.getPixelFromCoordinate(coordinate)

  var popupTL = [
    popupPosition[0] - popupSize[0] / 2,
    popupPosition[1] - 50 - popupSize[1]
  ]

  var popupTLCoords = this.map.getCoordinateFromPixel(popupTL)
  var mapTL = this.map.getCoordinateFromPixel([0, 0])
  var center = this.map
    .getView()
    .getCenter()
    .slice(0)

  if (popupTLCoords[0] < mapTL[0]) {
    center[0] -= mapTL[0] - popupTLCoords[0]
  }

  if (popupTLCoords[1] > mapTL[1]) {
    center[1] -= mapTL[1] - popupTLCoords[1]
  }

  var popupRB = [
    popupPosition[0] + popupSize[0] / 2,
    popupPosition[1] - 50 + popupSize[1]
  ]
  var popupRBCoords = this.map.getCoordinateFromPixel(popupRB)
  var mapRB = this.map.getCoordinateFromPixel(mapSize)

  if (popupRBCoords[0] > mapRB[0]) {
    center[0] -= mapRB[0] - popupRBCoords[0]
  }

  this.map.getView().animate({ center: center, duration: 500 })
}
